import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
export var withAnalyticsOnRender = function withAnalyticsOnRender(ContentBlock) {
  return function (props) {
    useEffect(function () {
      var _props$onRender;
      (_props$onRender = props.onRender) === null || _props$onRender === void 0 || _props$onRender.call(props);
    }, [props.onRender, props.deps]);
    return /*#__PURE__*/React.createElement(ContentBlock, _extends({}, props, {
      "data-t-id": "hoc-withAnalyticsOnRender"
    }));
  };
};